import useMediaQuery from "@mui/material/useMediaQuery";
import PROXY_CONFIG from "Config/ProxyConfig";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { isEmail, isPhoneNumber } from "utils/Functions";
import Modal from "../../../../../UiComponents/Modal/Modal";
import ListingPostedBy from "./../../../../common/ListingPostedBy/ListingPostedBy";
import CloseIconBlack from "./../icons/CloseIconBlack";
import modalStyle from "./ContactAgence.module.css";

import "react-phone-number-input/style.css";

import dynamic from "next/dynamic";
import secret, { encrypt } from "utils/CRYPTO/secret";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import CallActionsComponent from "../CallActionsComponent";

const PhoneInputComponent = dynamic(
  () => import("utils/PhoneInput/PhoneInput"),
  {
    ssr: false,
  }
);
export default function ContactAgence({
  listing,
  agence,
  contactAgenceHandler,
  t,
  lang,
}: {
  listing: any;
  agence: any;
  contactAgenceHandler: () => void;
  t: any;
  lang: any;
}) {
  const router = useRouter();
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const mobileDevice = useMediaQuery("(max-width: 1100px)");
  const [showNum, setShowNum] = useState<boolean>(false);
  const [message, setMessage] = useState<string>(
    listing
      ? t(
          `Bonjour j ai vu ${
            listing.vendu
              ? "ce bien vendu"
              : listing.transaction_type === "Vente"
              ? "le bien mis en vente"
              : listing.transaction_type === "Location"
              ? "le bien mis en location"
              : "ce projet neuf"
          }${
            listing.reference ? `, Ref ${listing.reference}, ` : " "
          } sur agenz ${
            listing.vendu
              ? "pourriez vous m'aider à vendre mon bien également ?"
              : `et je souhaite prendre rendez vous pour ${
                  listing.transaction_type === "Projets Neufs"
                    ? "mon projet immobilier"
                    : "une visite"
                } Merci `
          } `
        )
      : ""
  );
  useEffect(() => {
    if (listing) {
      setMessage(
        listing
          ? t(
              `Bonjour j ai vu ${
                listing.vendu
                  ? "ce bien vendu"
                  : listing.transaction_type === "Vente"
                  ? "le bien mis en vente"
                  : listing.transaction_type === "Location"
                  ? "le bien mis en location"
                  : "ce projet neuf"
              } sur agenz ${
                listing.reference ? ` Ref ${listing.reference}, ` : " "
              }${
                listing.vendu
                  ? "pourriez vous m'aider à vendre mon bien également ?"
                  : `et je souhaite prendre rendez-vous pour ${
                      listing.transaction_type === "Projets Neufs"
                        ? "mon projet immobilier"
                        : "une visite"
                    } Merci`
              } `
            )
          : ""
      );
    }
  }, [listing]);
  const [errors, seterrors] = useState<{
    name: boolean | string;
    email: boolean | string;
    phone: boolean | string;
    message: boolean | string;
  }>({
    name: false,
    email: false,
    phone: false,
    message: false,
  });
  const [sendMessageState, setSendMessageState] = useState<
    "IDLE" | "LOADING" | "SENT"
  >("IDLE");

  const registerContactAnnonce = () => {
    setSendMessageState("LOADING");

    // validate fields are filled
    const errors: {
      name: boolean | string;
      email: boolean | string;
      phone: boolean | string;
      message: boolean | string;
    } = { name: false, email: false, phone: false, message: false };

    if (name === null || name === "") {
      errors.name = "Champs requis";
    }
    if (email === null || email === "") {
      errors.email = "Champs requis";
    } else if (!isEmail(email)) {
      errors.email = "Format invalide";
    }
    if (phone === null || phone === "") {
      errors.phone = "Champs requis";
    }
    if (message === null || message === "") {
      errors.message = "Champs requis";
    }

    if (!Object.values(errors).reduce((acc, value) => acc || value, false)) {
      const data = {
        name,
        phone,
        email,
        message: `${message}`,
        date: new Date().toISOString(),
        job: null,
        user_id: currentUser?.uid,
        type: listing.vendu ? "Transaction" : "Annonce",
        transaction: null,
        annonce: listing._id,
        contributeur: agence ? agence.emailEntreprise : listing.agenceEmail,
        contributeurId: agence ? agence._id : listing.userId,
        quartier: listing.quartier,
        commune: listing.commune,
        province: listing.province,
        region: listing.region,
        typeDeBien: listing.type,
        typologie: listing.typologie,
        sdb: listing.sdb,
        surface: listing.surface,
        reference: listing.reference,
        transaction_type: listing.transaction_type,
        display: true,
      };

      api_call_v2(undefined, "post", "addContactMessageAnnonce", {
        data: encrypt(
          {
            data: data,
            annonceId: listing._id,
            agenceId: listing.userId,
          },
          secret
        ),
      })
        .then((result) => {
          setSendMessageState("SENT");

          window.history.pushState(
            {},
            "",
            router.asPath.includes("?")
              ? `${router.asPath}&form=true`
              : `${router.asPath}?form=true`
          );
        })
        .catch((err) => {
          setSendMessageState("SENT");
        });
    } else {
      seterrors(errors);
      setSendMessageState("IDLE");
    }
  };

  const currentUser = useSelector(
    (store: { auth: { user: any } }) => store.auth.user
  );

  useEffect(() => {
    if (currentUser) {
      setName(
        `${currentUser?.firstName ? currentUser?.firstName : ""}${
          currentUser?.lastName ? " " + currentUser?.lastName : ""
        }`
      );
      setEmail(currentUser?.email);
      setPhone(currentUser?.phone);
    }
  }, [currentUser]);

  const [rendring, setRendering] = useState<"CLIENT_SIDE" | "SERVER_SIDE">(
    "SERVER_SIDE"
  );

  const handleContactAgence = (e: any) => {
    e.preventDefault();
    registerContactAnnonce();
  };
  useEffect(() => {
    setRendering("CLIENT_SIDE");
  }, []);

  return (
    // <div>
    <Modal
      onClose={contactAgenceHandler}
      styleModal={{
        top: window.innerWidth < 990 ? "0px" : "30px",
        left: window.innerWidth < 990 ? "0px" : "calc(50% - 223px)",
        width: window.innerWidth < 990 ? "100%" : "446px",
        height: window.innerWidth < 990 ? "100vh" : "780px",
        zIndex: "100000",
        borderRadius: "0px",
        padding: window.innerWidth < 990 ? "20px 20px" : "5px 20px",
        position: "fixed",
        display: "flex",
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
      styleBackdrop={{
        zIndex: "49999",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.45)",
      }}
      className={modalStyle.contactContainer_modal}
    >
      <div className={modalStyle.innerContainer}>
        <div className={modalStyle.closeBtn} onClick={contactAgenceHandler}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <p className={modalStyle.contactTitle}>{t("Contactez")}</p>
        <div className={modalStyle.contentContainer}>
          {listing &&
            ((listing?.logo && listing.logo.url !== "") ||
              agence?.user_image) && (
              <ListingPostedBy
                agence={
                  listing?.agence
                    ? {
                        nameEntreprise: listing.agence.nameEntreprise
                          ? listing.agence.nameEntreprise
                          : listing.agenceName,
                        city: listing.agence.cityEntreprise
                          ? listing.agence.cityEntreprise
                          : listing.agenceCity
                          ? listing.agenceCity
                          : listing.province,
                        user_image: listing.agence.user_image
                          ? listing.agence.user_image
                          : listing.agenceImage,
                        vitrine: listing.agence.vitrine
                          ? listing?.agence.vitrine
                          : `https://agenz.ma/agence-immobiliere-maroc/profil/${listing.userId}`,
                      }
                    : {
                        nameEntreprise: listing.agenceName,
                        city: listing.agenceCity,
                        user_image: listing.agenceImage,
                        vitrine: `https://agenz.ma/agence-immobiliere-maroc/profil/${listing.userId}`,
                      }
                }
                modal={true}
                listing={listing}
              />
            )}
          <CallActionsComponent
            listing={listing}
            agence={agence}
            contactAgenceHandler={contactAgenceHandler}
            t={t}
            lang={lang}
            message={message}
            forContactModal={true}
            showNum={showNum}
            setShowNum={setShowNum}
            style={{ position: "static", boxShadow: "none", display:"flex" }}
          />

          <div className={modalStyle.formContainer} style={{}}>
            <form className={modalStyle.form} onSubmit={handleContactAgence}>
              <div
                className={modalStyle.formElementWrapper}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label>{t("Nom et Prénom")}</label>
                <input
                  type="text"
                  placeholder={t("Nom et prénom")}
                  className={modalStyle.formInput}
                  value={name || ""}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value !== "")
                      seterrors({ ...errors, name: "" });
                    else seterrors({ ...errors, name: "Champ requis" });
                  }}
                />
                {errors.name ? (
                  <span style={{ fontSize: "12px", color: "red" }}>
                    {errors.name}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className={modalStyle.formElementWrapper}>
                <label>{t("Email")}</label>
                <input
                  type="text"
                  placeholder={t("Email")}
                  className={modalStyle.formInput}
                  value={email || ""}
                  onChange={(e) => {
                    setEmail(e.target.value.trim());
                    if (e.target.value !== "" && isEmail(e.target.value))
                      seterrors({ ...errors, email: false });
                    else if (!isEmail(e.target.value))
                      seterrors({ ...errors, email: "Format invalide" });
                  }}
                />
                {errors.email ? (
                  <span style={{ fontSize: "12px", color: "red" }}>
                    {errors.email}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div
                className={modalStyle.formElementWrapper}
                style={{ width: "100%" }}
              >
                <label>{t("Numéro de téléphone")}</label>
                <PhoneInputComponent
                  className={`${modalStyle.input__phone} ${
                    errors.phone ? modalStyle.input_error_phone : ""
                  } `}
                  displayLabel={false}
                  placeholder={t("Numéro de téléphone")}
                  autoFormat={false}
                  name="phoneNumber"
                  id={errors.phone ? "telephoneError" : "telephone"}
                  data-cy="user-phone"
                  variant="outlined"
                  defaultCountry={"MA"}
                  countries={["MA", "TN", "FR"]}
                  value={phone}
                  error={errors.phone}
                  onChange={(e) => {
                    setPhone(e);
                    if (e !== "" && isPhoneNumber(e))
                      seterrors({ ...errors, phone: "" });
                    else if (!isPhoneNumber(e))
                      seterrors({ ...errors, phone: "Format invalide" });
                  }}
                  helperText={
                    errors.phone
                      ? t("Champs requis")
                      : errors.phone
                      ? t("Format incorrect")
                      : ""
                  }
                  errorPhone={errors.phone}
                  t={t}
                />
              </div>
              <div className={modalStyle.formElementWrapper}>
                <label>{t("Message")}</label>
                <textarea
                  value={message}
                  className={modalStyle.formInput}
                  style={{ height: "100px", padding: "5px" }}
                  onChange={(e) => {
                    setMessage(e.target.value);
                    if (e.target.value !== "")
                      seterrors({ ...errors, message: "" });
                    else seterrors({ ...errors, message: "Champ requis" });
                  }}
                />
                {errors.message ? (
                  <span style={{ fontSize: "12px", color: "red" }}>
                    {errors.message}
                  </span>
                ) : null}
              </div>
              {sendMessageState === "IDLE" && (
                <button
                  type="submit"
                  value="Submit"
                  style={{
                    width: window.innerWidth < 990 ? "100%" : "398px",
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  data-tracking="click"
                  data-value="contact-annonce-message"
                  className={modalStyle.btnFilled}
                  onClick={(e) => {
                    registerContactAnnonce();
                  }}
                >
                  {t("Envoyer")}
                </button>
              )}
              {sendMessageState === "LOADING" && (
                <button
                  style={{
                    width: mobileDevice ? "100%" : "398px",
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  className={modalStyle.btnFilled}
                >
                  <i className="fas fa-circle-notch fa-spin"></i>
                </button>
              )}
              {sendMessageState === "SENT" && (
                <button
                  className={modalStyle.btnFilled}
                  style={{
                    width: mobileDevice ? "100%" : "398px",
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {t("Votre message a bien été envoyé")}
                </button>
              )}
            </form>
            <p className={modalStyle.lawText}>
              {t("En cliquant sur 'Contacter gratuitement' vous acceptez nos")}{" "}
              <a target="_blank" href="/conditions-d-utilisation/">
                {t("conditions générales d'utilisation")}
              </a>{" "}
              {t("et notre")}{" "}
              <a target="_blank" href="/conditions-d-utilisation/">
                {t("politique de confidentialité")}
              </a>
              .{" "}
              {t(
                "Vous disposez d'un droit d'accès de rectification d'effacement et d'opposition aux informations vous concernant Pour exercer vos droits"
              )}{" "}
              <a target="_blank" href="/contact/">
                {t("Contactez-nous")}
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </Modal>
    // </div>
  );
}
